import { Error } from '../../../../icons'

// TODO: a quick hack, copied from InputField, should be moved to shared component that all can use
// But it may also needs to be made more generic and responsive

export const SimpleErrorMessage = ({ message }) => (
  <div className='flex justify-self-start items-center pt-1 gap-y-4'>
    <Error width='18px' height='18px' />
    <span className='text-sm text-[#DE3333] font-normal'>{message}</span>
  </div>
)
